import dynamic from "next/dynamic";
const WithTitleReviewsComponent = dynamic(()=>import("./with-title-reviews-component"));
import WithTitleReviewsConfig from "./with-title-reviews-config";
import WithTitleReviewsAdvancedConfig from "./with-title-reviews-advanced-config";
export default {
    WithTitleReviewsComponent,
    WithTitleReviewsConfig,
    WithTitleReviewsAdvancedConfig
};
